import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { id: "home", label: "Home", href: "/#home" },
    { id: "fleet", label: "Fleet", href: "/#fleet" },
    { id: "destinations", label: "Destinations", href: "/#destinations" },
    { id: "book", label: "Book", href: "/#book" },
    { id: "reviews", label: "Reviews", href: "/#reviews" },
    { id: "contact", label: "Contact", href: "/#contact" },
  ];

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-black/80 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-20 lg:h-24 flex items-center justify-between gap-6">
        <div className="flex items-center gap-6 lg:gap-10 flex-1">
          <Link to="/" data-testid="brand-logo" className="flex items-center group flex-shrink-0">
            <img
              src="/logo.png"
              alt="Black Yellow Taxi 24H"
              className="h-14 lg:h-20 w-auto"
            />
          </Link>

          <nav className="hidden lg:flex items-center gap-7">
            {links.map((l) => (
              <a
                key={l.id}
                href={l.href}
                data-testid={`nav-link-${l.id}`}
                className="text-sm uppercase tracking-[0.2em] font-semibold text-neutral-300 hover:text-[#FFC300] transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="flex items-center gap-4 flex-shrink-0">
          <a
            href="/#book"
            data-testid="navbar-book-btn"
            className="hidden lg:inline-flex bg-[#FFC300] text-black font-bold uppercase tracking-widest text-xs px-5 py-3 hover:bg-white transition-colors"
          >
            Book Now
          </a>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-white"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-black border-t border-white/10">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.id}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.id}`}
                className="text-sm uppercase tracking-[0.2em] font-semibold text-neutral-200 hover:text-[#FFC300]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="/#book"
              onClick={() => setOpen(false)}
              data-testid="mobile-book-btn"
              className="bg-[#FFC300] text-black font-bold uppercase tracking-widest text-xs px-5 py-3 text-center"
            >
              Book Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
